export default __webpack_public_path__ + "static/media/instagram-white.99a9ac90.svg";